<template>
	<page>
		<module enable-flex>
			<div class="head flex-start-center">
				<ul class="head-tab flex-center">
					<li v-for="(item, i) in typeOption" :key="i" :class="{'z-crt': currentType == item.value}" @click="currentType = item.value">{{item.name}}</li>
				</ul>
				<div class="flex-grow">
					<m-search v-show="currentType == 1" ref="search" column="3" :default-data="defaultSearch" style="width: 800px; padding: 0;" @search="currentArea = null; update();">
						<m-search-item label="工程师">
							<c-select ref="userSelect" name="user_ids" placeholder="请选择" async multiple @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="售后网点">
							<c-select ref="outletSelect" name="outlet_id" placeholder="请选择" async @search="searchOutlet"></c-select>
						</m-search-item>
						<m-search-item label="日期">
							<c-datetime type="date" name="location_date" :clear="false"></c-datetime>
						</m-search-item>
					</m-search>
				</div>
				<div v-if="currentArea" class="head-area flex-center" @click="currentArea = null; update();">
					<span>选中区域：{{currentArea.name}}</span>
					<i class="tf-cross"></i>
				</div>
			</div>

			<c-map ref="map" class="flex-grow"></c-map>

			<div v-if="staffList.length" class="staff-list">
				<c-scroll>
					<ul>
						<li v-for="(item, i) in staffList" :key="i">
							<dl @click="clickHandle(item)">
								<dt class="flex-start-center"><i class="tf">&#xe64e;</i>{{item.user_realname}}</dt>
								<dd>
									<p>归属网点：{{item.outlet_name}}</p>
									<p>当前预计完工：{{item.recent_finlish_date ? new Date(item.recent_finlish_date).format('MM月dd日') : '无'}}</p>
									<p>未完成工单：{{item.going_order_count}}笔</p>
									<ins>{{i + 1}}</ins>
								</dd>
							</dl>
						</li>
					</ul>
				</c-scroll>
			</div>
		</module>
	</page>
</template>

<script>
	import CoordTrans from '@/assets/script/coord_trans.js'
	
	export default {
		data() {
			return {
				typeOption: [{
					name: '售后工程师',
					value: 1
				}, {
					name: '客户',
					value: 2
				}],
				currentType: 1,
				currentArea: null,
				defaultSearch: {
					location_date: new Date().format('yyyy-MM-dd')
				},

				staffList: []
			}
		},

		watch: {
			currentType() {
				this.$refs.search.clear();
				this.currentArea = null;
				this.update();
			},

			currentArea(val) {
				if (!val) {
					this.$refs.map.reset();
				}
			}
		},

		mounted() {
			this.$refs.map.init(map => {
				this._map = map;
				this._map.addEventListener('moveend', this.update);
				this.update();
			})
		},

		beforeDestroy() {
			this._map && this._map.removeEventListener('moveend', this.update);
		},

		methods: {
			update(e) {
				let bs = this._map.getBounds();
				let sw = bs.getSouthWest();
				let ne = bs.getNorthEast();
				let zoom = this._map.getZoom();
				this._updateRequest && this._updateRequest.abort();
				let {lng: minLng, lat: minLat} = CoordTrans.cgcs2Gcj(sw.getLng(), sw.getLat());
				let {lng: maxLng, lat: maxLat} = CoordTrans.cgcs2Gcj(ne.getLng(), ne.getLat());
				this._updateRequest = this.request({
					url: '/distribution/location',
					data: Object.assign({
						min_lng: minLng,
						min_lat: minLat,
						max_lng: maxLng,
						max_lat: maxLat,
						region_type: zoom < 7 ? 1 : zoom < 10 ? 2 : 3
					}, this.$refs.search.get(), this.currentArea),
					success: ({aggregate_level, engineer_items, customer_items}) => {
						this.staffList = [];
						this._map.clearOverLays();
						if (aggregate_level == 'province') {
							(this.currentType == 1 ? engineer_items : customer_items).forEach(item => {
								let dom = $([
									'<div class="marker-summed">',
										'<div class="flex-column flex-center">',
											`<p class="flex-center"><i class="tf">${this.currentType == 1 ? '&#xe64e;' : '&#xe624;'}</i>${item.count}</p>`,
											`<p class="ellipsis">${item.province_name}</p>`,
										'</div>',
									'</div>',
								].join('')).click(() => {
									this.currentArea = {
										province_id: item.province_id,
										name: item.province_name
									}
									this.update();
								});
								this.$refs.map.overlay(item.centerLng, item.centerLat, dom[0]);
							});
						} else if (aggregate_level == 'city') {
							(this.currentType == 1 ? engineer_items : customer_items).forEach(item => {
								let dom = $([
									'<div class="marker-summed">',
										'<div class="flex-column flex-center">',
											`<p class="flex-center"><i class="tf">${this.currentType == 1 ? '&#xe64e;' : '&#xe624;'}</i>${item.count}</p>`,
											`<p class="ellipsis">${item.city_name}</p>`,
										'</div>',
									'</div>',
								].join('')).click(() => {
									this.currentArea = {
										city_id: item.city_id,
										name: item.city_name
									}
									this.update();
								});
								this.$refs.map.overlay(item.centerLng, item.centerLat, dom[0]);
							});
						} else if (aggregate_level == 'point') {
							let points = [];
							if (this.currentType == 1) {
								this.staffList = engineer_items.map(item => {
									let dom = $([
										'<div>',
											'<div class="marker-staff flex-center">',
												`<img src="${item.head_photo || require('@/assets/image/head_icon.jpg')}" alt="">`,
											'</div>',
										'</div>',
									].join(''))
									item.$marker = this.$refs.map.overlay(item.longitude, item.latitude, dom[0], {
										offsetY: '30px'
									});
									points.push(new T.gcjLngLat(item.longitude, item.latitude));
									return item;
								});
							} else {
								customer_items.forEach(item => {
									let dom = $([
										'<dl class="marker-customer">',
											`<dt class="flex-start-center"><i class="tf">&#xe624;</i><p class="flex-grow ellipsis">${item.customer_name}</p></dt>`,
											'<dd>',
												`<p class="ellipsis-2">${item.address}</p>`,
											'</dd>',
										'</dl>',
									].join(''))
									this.$refs.map.overlay(item.longitude, item.latitude, dom[0]);
									points.push(new T.gcjLngLat(item.longitude, item.latitude));
								});
							}
							this.currentArea && !e && this._map.setViewport(points);
						}
					}
				});
			},
			
			searchUser(keyword, resolve) {
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
                        is_engineer: 1,
                        keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			searchOutlet(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_OUTLET',
						keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.outlet_name,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			clickHandle(item) {
				this.staffList.forEach(temp => {
					$(temp.$marker._dom).children().css({
						zIndex: 0
					}).children().css({
						opacity: '.9',
						transform: 'scale(1)'
					});
				});
				$(item.$marker._dom).children().css({
					zIndex: 1
				}).children().css({
					opacity: 1,
					transform: 'scale(1.6)'
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.head {
		z-index: 1;
		position: relative;
		box-sizing: border-box;
		height: 44px;
		padding: 0 20px;
		background: #fff;
		
		&-tab {
			gap: 6px;
			height: 32px;
			border-radius: 16px;
			padding: 0 6px;
			margin-right: 10px;
			background: #F5F5F5;

			li {
				box-sizing: border-box;
				height: 24px;
				border-radius: 12px;
				padding: 0 8px;
				line-height: 24px;
				font-size: 13px;
				text-align: center;
				cursor: pointer;
				
				&:not(.z-crt):hover {
					color: var(--color-main);
				}

				&.z-crt {
					color: #fff;
					background: var(--color-main);
				}
			}
		}

		&-area {
			gap: 6px;
			box-sizing: border-box;
			height: 28px;
			border: 1px dashed var(--color-main);
			border-radius: 14px;
			padding: 0 10px;
			font-size: 12px;
			color: #333;
			cursor: pointer;

			&:hover {
				color: var(--color-main);
			}

			i {
				color: #f00;
			}
		}
	}

	.staff-list {
		position: absolute;
		right: 0;
		top: 44px;
		width: 280px;
		height: calc(100vh - 200px);
		pointer-events: none;

		li {
			padding: 10px 8px 0;
			pointer-events: initial;

			&:nth-last-child(1) {
				padding-bottom: 10px;
			}

			dl {
				position: relative;
				border-radius: 6px;
				padding: 4px 22px 6px;
				background: rgba(245,245,245,.9);
				box-shadow: 0 0 8px 0 rgba(0,0,0,.2);
				cursor: pointer;

				&:hover {
					box-shadow: 0 0 8px 0 rgba(0,0,0,.3);
				}
				
				dt {
					gap: 8px;
					height: 38px;
					font-size: 16px;
					font-weight: bold;
				}

				dd {
					line-height: 20px;
					font-size: 13px;

					ins {
						position: absolute;
						left: 0;
						top: 0;
						box-sizing: border-box;
						min-width: 16px;
						border-radius: 6px 0 6px 0;
						padding: 0 4px;
						line-height: 16px;
						font-size: 12px;
						text-align: center;
						color: #fff;
						background: #f55;
					}
				}
			}
		}
	}

	>>> .marker-summed {
		cursor: pointer;

		&:hover {
			z-index: 1;
		}

		&:before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 75px;
			height: 75px;
			border-radius: 50% 50% 50% 0;
			background: rgba(7,100,245,.8);
			transform: rotate(-45deg);
			transition: box-shadow .15s ease;

			^[-1]:hover^[-1..-1] {
				box-shadow: 0 0 8px rgba(7,100,245,.6);
			}
		}
		
		div {
			position: relative;
			box-sizing: border-box;
			width: 75px;
			height: 90px;
			padding: 0 8px 10px;
			line-height: 22px;
			font-size: 12px;
			color: #fff;

			p {
				max-width: 100%;
				
				&:nth-child(1) {
					gap: 5px;
					font-size: 16px;
				}
			}
		}
	}

	>>> .marker-staff {
		box-sizing: border-box;
		width: 40px;
		height: 40px;
		border: 2px solid var(--color-main);
		border-radius: 50%;
		overflow: hidden;
		background: #fff;
		opacity: .9;
		
		img {
			max-width: 100%;
			max-height: 100%;
		}
	}

	>>> .marker-customer {
		box-sizing: border-box;
		width: 156px;
		border-radius: 4px;
		padding: 0 10px;
		color: #fff;
		background: rgba(7,100,245,.8);

		&:hover {
			z-index: 1;
		}

		&:before {
			content: '';
			position: absolute;
			left: 50%;
			bottom: -6px;
			border-top: 6px solid rgba(7,100,245,.8);
			border-left: 6px solid rgba(0,0,0,0);
			border-right: 6px solid rgba(0,0,0,0);
			margin-left: -6px;
		}
		
		dt {
			gap: 8px;
			height: 30px;
			font-size: 14px;
		}

		dd {
			padding-bottom: 6px;
			line-height: 18px;
			font-size: 12px;
		}
	}
</style>
